import { AddressFormData, CustomerResource } from '../../@api/Sylius';
import { Address, CustomerAddress } from '../../Address/Address';
import { transformIso8601DateTimeStringToDateString } from '../../Date/DateTransformers';
import { Customer } from './Customer';

export const transformAddressToAddressFormData = (address: Address, customer?: Customer): AddressFormData => ({
    label: address.label,
    firstName: customer?.firstName || '[firstName]',
    lastName: customer?.lastName || '[lastName]',
    phoneNumber: customer?.phoneNumber || address.phoneNumber,
    street: address.street,
    number: address.houseNumber,
    addition: address.addition,
    city: address.city,
    postcode: address.postalCode.toUpperCase(),
    countryCode: address.country,
});

export const transformToCustomer = (resource: CustomerResource, id: string, customerAddresses?: CustomerAddress[]): Customer => {
    const addresses = customerAddresses || [];
    const company = undefined; // TODO: Add company (waiting to be added to API)

    const birthday = resource.birthday
        ? transformIso8601DateTimeStringToDateString(resource.birthday)
        : undefined;

    return {
        id,
        addresses,
        firstName: resource.firstName || '',
        lastName: resource.lastName || '',
        email: resource.email,
        birthday,
        phoneNumber: resource.phoneNumber || '',
        company,
    };
};
